<script>
  import { _ } from 'svelte-i18n'
  import { buy_modal_initiator } from '../stores'
  import Button from '../elements/Button.svelte'
  export let selected_plan = "yearly"
  export let subscription_type = "pro" // "pro" or "business"
  
  function handleClick() {
    window.fastspring.builder.clean()

    // subscription products:
    // 'wordmark-pro-12-subscription'
    // 'wordmark-pro-monthly-subscription'
    // 'wordmark-business-12-subscription'
    // 'wordmark-business-monthly-subscription'
    const product_str = 'wordmark-' + subscription_type + '-'
    const plan_str = selected_plan === 'yearly' ? '12' : 'monthly'
    const full_name = product_str + plan_str + "-subscription"
    
    console.log('Account - initiating purchase for: ' + full_name)

    window.fastspring.builder.add(full_name)
    fastspring.builder.checkout()

    if (typeof window.gtag == "undefined") return
    gtag('event', 'buy_button_clicked', {
      'initiator': $buy_modal_initiator,
      'subscription_type': subscription_type
    });
  }

  // Set the appropriate button text based on subscription type
  let buttonText = $_('buttons.subscribeTo') + ' ' + (subscription_type === 'business' ? '<b>' + $_('app.businessName') + '</b>' : '<b>' + $_('app.proName') + '</b>'  )
</script>

<Button kind="accent" on:click={handleClick}>
  <slot>
    {@html buttonText}
  </slot>
</Button>